export const PICK_UP_PLACEHOLDER = "Pick-up location";
export const DROP_OFF_PLACEHOLDER = "Drop-off location";
export const DROP_OFF_AT_THE_PICKUP_LOCATION = "Drop-off at the same location";
export const SAME_AS_PICKUP = "Same as pickup";
export const SEARCH = "Search Cars";
export const MISSING_INFO_SEARCH_ERROR =
  "To continue, please complete all required fields.";
